import * as React from 'react'
import { FC } from 'react'
import { IDiscountCode } from '@user/store/discountCode/typings'
import { getStyles } from './styling'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

interface Props {
  onOpen: () => void
  referralDiscountCode: IDiscountCode
}

export const Contents: FC<Props> = (props) => {
  const { onOpen, referralDiscountCode } = props
  const styles = getStyles(useTheme())
  return (
    <Box sx={styles.container}>
      <Box component="span" sx={styles.bold}>
        Applied Referral Code
      </Box>
      <Box component="span" sx={styles.details}>
        {referralDiscountCode.code} - {referralDiscountCode.name}
      </Box>
      <Box sx={styles.viewFullDetailsLink} component="span" onClick={onOpen}>
        View Full Details
      </Box>
    </Box>
  )
}
